/* src/app/main/pages/home-page/component/latest-news/latest-news.component.css */
@media (min-width: 1024px) {
  .latest-news-row p.sub-text {
    width: 933px;
    margin-left: auto;
    margin-right: auto;
  }
}
.latest-news-row {
  background-color: #F8F9FF;
  position: relative;
}
.latest-news-row::before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/wew.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 190px;
  height: 100%;
  top: -85px;
}
.latest-news-row::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/image.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 190px;
  height: 300px;
  bottom: -28px;
}
.latest-news-row .card {
  background-color: transparent;
  border: none;
}
.latest-news-row .card-body {
  padding-left: 0px;
  padding-right: 0px;
}
.latest-news-row .card-body p {
  font-size: 15px;
}
.latest-news-row .horizontal-cards .card {
  margin-bottom: 30px;
}
.latest-news-row .horizontal-cards .card-body {
  padding: 0px;
}
.horizontal-cards iframe::-webkit-scrollbar {
  display: none;
}
@media (min-device-width: 1920px) {
  .latest-news-row .card-body p {
    font-size: 19px !important;
  }
  .horizontal-cards iframe {
    height: 700px !important;
  }
}
@media (min-device-width: 1600px) {
  .horizontal-cards iframe {
    height: 610px;
  }
  .latest-news-row p.sub-text {
    width: 1230px;
  }
}
@media (min-device-width: 1440px) {
  .latest-news-row .card-title {
    font-size: 28px;
  }
  .latest-news-row .card-body p {
    font-size: 16px;
  }
}
/*# sourceMappingURL=latest-news.component.css.map */
